import { MenuPagesResponse } from './AppData';

const menuPagesUrl =
	process.env.NODE_ENV === 'development'
		? `${process.env.PUBLIC_URL}/menupages.json`
		: 'https://api.genjinorthyork.com/menupages';

export const getData = async (): Promise<MenuPagesResponse> => {
	const res = await fetch(menuPagesUrl, {
		headers: {
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	});

	return res.json(); // promise
};
